import { render } from "./HomeGestor.vue?vue&type=template&id=2a052881"
import script from "./HomeGestor.vue?vue&type=script&lang=js"
export * from "./HomeGestor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__